import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Page_settings } from '../../config/page_settings';
import strings from '../../lang/strings';
import { observer } from 'mobx-react';
import SidebarLeft from '../../components/sidebar/sidebar_left';
import PageSubHeader from '../../components/common/page_sub_header';
import { MenuMy } from '../../config/page_route';
import { rootStore } from '../../mobx/store';
import ReactPaginate from 'react-paginate';
import { PAGECOUNT } from '../../config/const';
import TableHeader from '../../components/control/table/table_header';
import {TableCellNoColor} from '../../components/control/table/table_cell';
import { customDateTimeFormat } from '../../helper/common';

const AlarmList = observer((props) => {
  const context = useContext(Page_settings);
  const [pageCount, setPageCount] = useState(1);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [empty, setEmpty] = useState(false);
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  const active = 7;

  const tbHeaders = [
    {
      name: strings.num,
      class: 'td-event-num',
    },
    {
      name: strings.title,
      class: 'td-event-title text-line ph-40 sm-ph-15',
      center: false
    },
    {
      name: strings.date,
      class: 'td-event-date',
    },
  ]

  useEffect(() => {
    getList(1);
  }, []);

  useEffect(() => {
    getList(1);
  }, [showUnreadOnly])

  const getList = (page) => {
    context.post(
      'member/alarm_list',
      { page: page, count: PAGECOUNT, unread_only : showUnreadOnly },
      (response) => {
        setList(response.list);
        setPageCount(response.page_count);
        setEmpty(response.page_count === 0);
      },
      false,
      (err) => {
        context.showAlert(err.msg);
      }
    );
  };

  const handlePageClick = (component) => {
    const selectedPage = component.selected + 1;
    setPage(selectedPage);
    getList(selectedPage);
  };

  const goDetail = (alarmId, $elem) => {
    $elem.classList.remove('unread');
    $elem.classList.add('read');
    context.showAlarm(alarmId, true);
  };

  return (
    <React.Fragment>
      <div className="content-container">
        <SidebarLeft menu={MenuMy} active={active} history={props.history} />
        <div className="im-container">
          <PageSubHeader
            pageName={strings.alarm_list}
            pageMenu1={strings.main}
            pageMenu2={strings.mypage}
            pageMenu={strings.alarm_list}
          />
          <div className={'mt-30'}>
          <div
            className="filter-unread-toggle fs-14 sm-fs-12"
            onClick={() => setShowUnreadOnly(!showUnreadOnly)}
          >
            {showUnreadOnly ? '모든 알람 보기' : '읽지 않은 알람만 보기'}
            </div>
          </div>
          <TableHeader className={'mt-10'} headers={tbHeaders} />
          <div className="event-container sm-mt-15 mb-40">
            {list.map((info, index) => (
              <div key={index} className={`tb-row cursor-point tb-alarm clickable-row-highlight ${info.is_read == 1 ? 'read': 'unread'}`} onClick={(event) => {goDetail(info.alarm_id, event.currentTarget)}}>
                <TableCellNoColor
                  value={(page - 1) * PAGECOUNT + index + 1}
                  className={tbHeaders[0].class}
                  center={tbHeaders[0].center}
                  child={null}
                />
                <TableCellNoColor
                  value={info.alarm_title}
                  className={`${tbHeaders[1].class} hover-text-accent`}
                  center={tbHeaders[1].center}
                  child={null}
                />
                <TableCellNoColor
                  value={customDateTimeFormat(info.alarm_createdat)}
                  className={tbHeaders[2].class}
                  center={tbHeaders[2].center}
                  child={null}
                />
              </div>
            ))}
            {empty && (
              <div className="d-center color-3a3335 fs-16 f-b empty_label hx-100">
                {strings.empty_alarm}
              </div>
            )}
          </div>
          {pageCount > 1 && (
            <ReactPaginate
              previousLabel={''}
              nextLabel={''}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
});

export default withRouter(AlarmList);
